// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3O-yg","newExpiryDate":"styles_newExpiryDate__1YDuW","footer":"styles_footer__Jd4GW"};